export type CourtKey = 'padel-1' | 'padel-2' | 'tennis-1' | 'tennis-2' | 'tennis-3';

export const CANONICAL_KEYS: CourtKey[] = ['padel-1', 'padel-2', 'tennis-1', 'tennis-2', 'tennis-3'];

/**
 * Normalize UI labels like "Padel 1", "PADel-1", "Tennis 3", "Platz 2 – Padel" -> canonical key
 */
export function normalizeCourtKey(input: string): CourtKey | undefined {
  const s = (input || '').toLowerCase().trim()
    .replace('padel', 'padel')          // tolerate "padel"
    .replace('platz', '')                // tolerate "Platz 1 – Padel"
    .replace(/[–—]/g, '-')               // dashes to hyphen
    .replace(/\s+/g, '-')
    .replace(/:+/g, '')
    .replace(/-+/g, '-');

  // common patterns: "padel-1", "padel-2", "tennis-1/2/3"
  const m = s.match(/(padel|tennis)-([123])/);
  if (!m) {
    if (import.meta.env.DEV) {
      console.warn('[normalizeCourtKey] Could not normalize:', input);
    }
    return undefined;
  }

  return `${m[1]}-${m[2]}` as CourtKey;
}
